<template>
  <div>
    <template v-for="(idx,i) in indices">
      <div class="pl-50" v-bind:key="'idx-'+i" v-if="(allowedIndices.indexOf(idx.cod) !== -1 || idx.parent != '') && (allowedColors.indexOf(idx.light) !== -1 || (allowedColors.indexOf('nocolor') !== -1 && idx.light == ''))">
        <div class="row-report mb-20">
          <div @click="indexDetails(idx)">
            <div class="light" :class="idx.light != 'nocolor' ? idx.light : ''"></div>
            <div class="overflow-scroll-mobile">
              <span>Ref: {{ idx.ref }}</span>
              <span>Cod: {{ idx.cod }}</span>
              <span>{{ idx.title }}</span>
            </div>
          </div>
        </div>
        <report-index :allowedColors="allowedColors" :allowedIndices="allowedIndices" :indices="idx.indices" @indexDetails="(idx) => indexDetails(idx)"></report-index>
      </div>
    </template>
  </div>
</template>

<script>
// import axios from "axios"
// import Vue from "vue"
export default {
  name: "ReportIndex",
  props: ['indices', 'allowedColors', 'allowedIndices'],
  data: function() {
    return {
    }
  },
  methods: {
    indexDetails: function(idx) {
      this.$emit('indexDetails', idx)
    }
  },
  created: function() {
  },
  mounted: function() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>